/**
 * slide-cart.js
 * AP Slide Cart — fetches live cart data, renders items + upsells,
 * free shipping bar, trust strip, analytics.
 */
(function () {
  'use strict';

  var overlay    = document.getElementById('ap-cart-overlay');
  var drawer     = document.getElementById('ap-cart-drawer');
  var itemsEl    = document.getElementById('ap-cart-items');
  var upsellEl   = document.getElementById('ap-cart-upsell');
  var emptyEl    = document.getElementById('ap-cart-empty');
  var subtotalEl = document.getElementById('ap-cart-subtotal');
  var countBadge = document.getElementById('ap-cart-count-badge');
  var footerEl   = document.getElementById('ap-cart-footer');
  var fsbWrap    = document.getElementById('ap-free-shipping-bar');
  var fsbMsg     = document.getElementById('ap-fsb-message');
  var fsbFill    = document.getElementById('ap-fsb-fill');

  if (!drawer) return;

  var cfg = window.AP_CART_CONFIG || { freeShippingEnabled: true, freeShippingThreshold: 6000 };

  // ── Helpers ──────────────────────────────────────────────────
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Open / Close ─────────────────────────────────────────────
  function showDrawer() {
    document.body.classList.add('ap-cart-open');
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    setTimeout(function () {
      var closeBtn = document.getElementById('ap-cart-close');
      if (closeBtn) closeBtn.focus();
    }, 350);
  }

  // open() without pre-fetched data — fetches first then shows
  function open() {
    fetchCart().then(function (cart) {
      render(cart);
      showDrawer();
    });
  }

  function close() {
    document.body.classList.remove('ap-cart-open');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
  }

  // ── Fetch cart ───────────────────────────────────────────────
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // ── Free shipping bar ─────────────────────────────────────────
  function renderFreeShipping(subtotalCents) {
    if (!fsbWrap || !fsbMsg || !fsbFill) return;
    var threshold = cfg.freeShippingThreshold || 0;

    if (!cfg.freeShippingEnabled || !threshold) {
      fsbWrap.style.display = 'none';
      return;
    }

    fsbWrap.style.display = 'block';
    var remaining = threshold - subtotalCents;

    if (remaining <= 0) {
      // Unlocked!
      fsbWrap.classList.add('is-unlocked');
      fsbMsg.innerHTML = '🎉 <strong>You unlocked free shipping!</strong>';
      fsbFill.style.width = '100%';
    } else {
      fsbWrap.classList.remove('is-unlocked');
      var pct = Math.min(100, Math.round((subtotalCents / threshold) * 100));
      fsbMsg.innerHTML = 'Add <strong>' + money(remaining) + '</strong> more for <strong>free shipping</strong> 🚚';
      // Animate fill — set to 0 first so transition plays each render
      fsbFill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fsbFill.style.width = pct + '%';
        });
      });
    }
  }

  // ── Render everything ─────────────────────────────────────────
  function render(cart) {
    var itemCount   = cart.item_count || 0;
    var subtotalCents = cart.items_subtotal_price || cart.total_price || 0;

    // Nav badge sync (Turbo theme uses .cart-link__bubble or similar)
    if (countBadge) {
      countBadge.textContent = itemCount > 0 ? '(' + itemCount + ')' : '';
    }
    // Also update Turbo's own cart count bubbles if present
    document.querySelectorAll('[data-cart-count], .cart-link__bubble, .site-header__cart-count').forEach(function (el) {
      el.textContent = itemCount;
    });

    if (itemCount === 0) {
      itemsEl.innerHTML = '';
      upsellEl.innerHTML = '';
      emptyEl.style.display = 'block';
      footerEl.style.display = 'none';
    } else {
      emptyEl.style.display = 'none';
      footerEl.style.display = 'flex';
      renderItems(cart);
      renderUpsells(cart);
      renderFreeShipping(subtotalCents);
    }

    if (subtotalEl) subtotalEl.textContent = money(subtotalCents);
  }

  // ── Cart items ────────────────────────────────────────────────
  function renderItems(cart) {
    var html = '';
    cart.items.forEach(function (item) {
      var props = '';
      Object.keys(item.properties || {}).forEach(function (k) {
        var v = item.properties[k];
        if (!v || k.charAt(0) === '_') return;
        // Hide raw photo URLs — just show a checkmark
        var display = (k === 'Custom Image Upload')
          ? '📸 Photo uploaded ✓'
          : (String(v).length > 42 ? String(v).substring(0, 40) + '…' : String(v));
        props += '<div class="ap-ci-prop"><span class="ap-ci-prop-key">' + escHtml(k) + ':</span> ' + escHtml(display) + '</div>';
      });

      var imgSrc = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120_crop_center$1$2')
        : '';
      var imgTag = imgSrc
        ? '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(item.product_title) + '" class="ap-ci-img" loading="lazy">'
        : '<div class="ap-ci-img ap-ci-img--placeholder">🥔</div>';

      html += '<div class="ap-cart-item" data-key="' + escHtml(item.key) + '">'
        + '<div class="ap-ci-image-wrap">' + imgTag + '</div>'
        + '<div class="ap-ci-details">'
        +   '<div class="ap-ci-title">' + escHtml(item.product_title) + '</div>'
        +   (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="ap-ci-variant">' + escHtml(item.variant_title) + '</div>' : '')
        +   props
        +   '<div class="ap-ci-bottom">'
        +     '<div class="ap-ci-qty">'
        +       '<button class="ap-ci-qty-btn" data-key="' + escHtml(item.key) + '" data-delta="-1" aria-label="Decrease quantity">−</button>'
        +       '<span class="ap-ci-qty-num">' + item.quantity + '</span>'
        +       '<button class="ap-ci-qty-btn" data-key="' + escHtml(item.key) + '" data-delta="1" aria-label="Increase quantity">+</button>'
        +     '</div>'
        +     '<div class="ap-ci-price">' + money(item.line_price) + '</div>'
        +   '</div>'
        + '</div>'
        + '<button class="ap-ci-remove" data-key="' + escHtml(item.key) + '" aria-label="Remove ' + escHtml(item.product_title) + '">'
        +   '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" d="M4 4l12 12M16 4L4 16"/></svg>'
        + '</button>'
        + '</div>';
    });
    itemsEl.innerHTML = html;

    // Qty buttons — dim item while updating
    itemsEl.querySelectorAll('.ap-ci-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemEl  = btn.closest('.ap-cart-item');
        if (itemEl) itemEl.style.opacity = '0.45';
        var key    = btn.dataset.key;
        var delta  = parseInt(btn.dataset.delta);
        var match  = cart.items.find(function (i) { return i.key === key; });
        var newQty = match ? match.quantity + delta : 1;
        if (newQty < 1) newQty = 0;
        changeItem(key, newQty);
      });
    });

    // Remove buttons
    itemsEl.querySelectorAll('.ap-ci-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemEl = btn.closest('.ap-cart-item');
        if (itemEl) { itemEl.style.opacity = '0.45'; itemEl.style.pointerEvents = 'none'; }
        changeItem(btn.dataset.key, 0);
      });
    });
  }

  // ── Upsells ───────────────────────────────────────────────────
  function renderUpsells(cart) {
    var upsells = window.AP_UPSELLS || [];
    if (!upsells.length) { upsellEl.innerHTML = ''; return; }

    var cartVariantIds = cart.items.map(function (i) { return i.variant_id; });
    var toShow = upsells.filter(function (u) {
      return cartVariantIds.indexOf(u.variant_id) === -1;
    }).slice(0, 2);

    if (!toShow.length) { upsellEl.innerHTML = ''; return; }

    var html = '<div class="ap-upsell-header">🎉 Complete Your Potato Experience</div><div class="ap-upsell-list">';
    toShow.forEach(function (u) {
      html += '<div class="ap-upsell-item" data-variant-id="' + u.variant_id + '">'
        + (u.image
            ? '<img src="' + escHtml(u.image) + '" alt="' + escHtml(u.title) + '" class="ap-upsell-img" loading="lazy">'
            : '<div class="ap-upsell-img ap-upsell-img--placeholder">🎁</div>')
        + '<div class="ap-upsell-info">'
        +   '<div class="ap-upsell-title">' + escHtml(u.title) + '</div>'
        +   '<div class="ap-upsell-price">' + money(u.price) + '</div>'
        + '</div>'
        + '<button class="ap-upsell-add-btn" data-variant-id="' + u.variant_id + '">+ Add</button>'
        + '</div>';
    });
    html += '</div>';
    upsellEl.innerHTML = html;

    upsellEl.querySelectorAll('.ap-upsell-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId), quantity: 1 }] })
        })
          .then(function () { return fetchCart(); })
          .then(function (cart) {
            // Flash "Added ✓" before re-render
            btn.textContent = 'Added ✓';
            btn.classList.add('is-added');
            setTimeout(function () { render(cart); }, 600);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          });
      });
    });
  }

  // ── Change item quantity ──────────────────────────────────────
  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (err) { console.error('Cart change error:', err); });
  }

  // ── Analytics ─────────────────────────────────────────────────
  function fireAddToCartAnalytics(items, cartData) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
          currency: 'USD',
          value: items.reduce(function (s, i) { return s + (i.price || 0) * (i.quantity || 1); }, 0) / 100,
          items: items.map(function (i) {
            return { item_id: String(i.id), item_name: i.title || '', price: (i.price || 0) / 100, quantity: i.quantity || 1 };
          })
        });
      }
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_ids: items.map(function (i) { return String(i.id); }),
          content_type: 'product',
          value: items.reduce(function (s, i) { return s + (i.price || 0) * (i.quantity || 1); }, 0) / 100,
          currency: 'USD'
        });
      }
      if (window._learnq) {
        window._learnq.push(['track', 'Added to Cart', {
          $value: (cartData ? cartData.total_price : 0) / 100,
          AddedItemProductName: items[0] ? items[0].title : '',
          AddedItemSKU: items[0] ? String(items[0].id) : '',
          CartURL: window.location.origin + '/cart'
        }]);
      }
    } catch (e) { /* never break UX for analytics */ }
  }

  // ── Public API ────────────────────────────────────────────────
  window.AP_Cart = {
    open: open,
    close: close,
    // Called after /cart/add.js — we already have fresh cart data, no re-fetch needed
    openAfterAdd: function (addedItems, cartData) {
      fireAddToCartAnalytics(addedItems, cartData);
      render(cartData);
      showDrawer();
    }
  };

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

})();
